import { render, staticRenderFns } from "./BCardBtn.vue?vue&type=template&id=8bf8f64a&scoped=true&"
import script from "./BCardBtn.vue?vue&type=script&lang=js&"
export * from "./BCardBtn.vue?vue&type=script&lang=js&"
import style0 from "./BCardBtn.vue?vue&type=style&index=0&id=8bf8f64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf8f64a",
  null
  
)

export default component.exports